import Html from 'slate-html-serializer'
import * as React from 'react';
import {SlateMarkBase} from "shared/controls/SingleInputs/SlateEditor/Marks/SlateMarkBase";
import {CSSProperties} from "react";
export class HTMLSerializer {
    private static html:Html;

    public static GetInstance(marks:SlateMarkBase[]){
        if(HTMLSerializer.html==null)
            HTMLSerializer.html=new Html({rules:[
                    {
                        serialize(obj, children) {
                            if (obj.object == 'block') {
                                switch (obj.type) {
                                    case 'code':
                                        return (
                                            <pre>
                                                <code>{children}</code>
                                            </pre>
                                        )
                                    case 'paragraph':
                                        return <p className={obj.data.get('className')}>{children}</p>
                                    case 'quote':
                                        return <blockquote>{children}</blockquote>
                                    case 'line':
                                        return <p>{children} </p>



                                }
                            }

                            if(obj.object=='inline')
                            {
                                switch (obj.type)
                                {
                                    case 'field':
                                        let marks=[];
                                        try{
                                            marks=obj.nodes.get(0).leaves.get(0).marks.toJS();
                                        }catch(e)
                                        {

                                        }
                                        let styles:CSSProperties={};
                                        for(let currentMark of marks)
                                        {
                                            switch (currentMark.type) {
                                                case "color":
                                                    styles.color=currentMark.data.hex;
                                                    break;
                                                case 'size':
                                                    styles.fontSize=currentMark.data.size;
                                                    break;
                                                case 'bold':
                                                    styles.fontWeight='bold';
                                                    break;
                                                case 'underline':
                                                    styles.textDecoration='underline';
                                                    break;
                                                case 'italic':
                                                    styles.fontStyle='italic';

                                            }

                                        }
                                        return <span style={styles} className={'subField'} data-fieldid={obj.data.get('FieldId')} data-code={JSON.stringify(obj.data.toJSON())}>{`{Field ${obj.data.get('FieldId')}}`}</span>
                                }
                            }

                            if(obj.object=='mark')
                            {
                                switch (obj.type) {
                                    case 'color':
                                        return <span style={{color:obj.data.get('hex')}}>{children}</span>;
                                    case 'size':
                                         return <span  style={{fontSize:obj.data.get('size'),lineHeight:obj.data.get('size').toString().indexOf('px')>=0?obj.data.get('size'):obj.data.get('size') +'px'}}>{children}</span>;
                                    case 'bold':
                                        return <strong>{children}</strong>;
                                    case 'italic':
                                        return <span style={{fontStyle:'italic'}}>{children}</span>;
                                    case 'underlined':
                                        return <span style={{textDecoration:'underline'}}>{children}</span>;
                                    default:
                                        for(let mark of marks)
                                        {
                                            let node:any=mark.RenderMark(obj,children,null);
                                            if(node!=null)
                                                return node;
                                        }
                                }
                            }
                        },
                        deserialize(el:HTMLElement,next){

                            if(el.tagName=='SPAN'&&el.getAttribute('data-code')!=null)
                            {
                                try {
                                    let data = JSON.parse(el.getAttribute('data-code'));

                                    if(data.SubType=='field')
                                    {
                                        let field=  {
                                            object:'inline',
                                            type:'field',
                                            data:data,
                                            nodes: [
                                                {
                                                    object:'text',
                                                    leaves:[
                                                        {
                                                            object:'leaf',
                                                            marks:[]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }

                                        let marks=field.nodes[0].leaves[0].marks;

                                        if(el.style.color!='')
                                        {
                                            marks.push({
                                                object:'mark',
                                                type:'color',
                                                data:{
                                                    hex:el.style.color
                                                }
                                            })
                                        }

                                        if (el.style.textDecoration.toLowerCase() == 'underline') {
                                            marks.push( {
                                                object: 'mark',
                                                type: 'underlined',
                                                nodes: next(el.childNodes)
                                            });
                                        }

                                        if (el.style.fontStyle == 'italic') {
                                            marks.push( {
                                                object: 'mark',
                                                type: 'italic',
                                                nodes: next(el.childNodes)
                                            });
                                        }

                                        if(el.style.fontSize!='')
                                            marks.push( {
                                                object: 'mark',
                                                type: 'size',
                                                data: {
                                                    size: el.style.fontSize,
                                                },
                                                nodes: next(el.childNodes)
                                            });

                                        if(el.style.fontWeight=='bold')
                                        {
                                            marks.push( {
                                                object: 'mark',
                                                type: 'bold',
                                                nodes: next(el.childNodes)
                                            });
                                        }
                                        return field;
                                    }



                                }catch(ex)
                                {

                                }

                            }

                            if(el.tagName.toLowerCase()=='p')
                            {
                                return {
                                    object: 'block',
                                    type: 'paragraph',
                                    data: {
                                        className: el.getAttribute('class'),
                                    },
                                    nodes: next(el.childNodes)
                                }
                            }

                            if(el.tagName.toLowerCase()=='strong')
                            {
                                return {
                                    object: 'mark',
                                    type: 'bold',
                                    nodes: next(el.childNodes)
                                }
                            }

                            if(el.style!=null) {

                                if (el.style.textDecoration.toLowerCase() == 'underline') {
                                    return {
                                        object: 'mark',
                                        type: 'underlined',
                                        nodes: next(el.childNodes)
                                    }
                                }

                                if (el.style.fontStyle == 'italic') {
                                    return {
                                        object: 'mark',
                                        type: 'italic',
                                        nodes: next(el.childNodes)
                                    }
                                }
                            }

                            if(el.tagName.toLowerCase()=='span')
                            {
                                if(el.style.color!='')
                                    return {
                                        object: 'mark',
                                        type: 'color',
                                        data: {
                                            hex: el.style.color,
                                        },
                                        nodes: next(el.childNodes)
                                    }

                                if(el.style.fontSize!='')
                                    return {
                                        object: 'mark',
                                        type: 'size',
                                        data: {
                                            size: el.style.fontSize,
                                        },
                                        nodes: next(el.childNodes)
                                    }
                            }

                            for(let currentMark of marks)
                            {
                                let element =currentMark.Serialize(el,next);
                                if(element!=null)
                                    return element;
                            }


                        }
                    }

            ]});
        return HTMLSerializer.html;

    }

    public static Serialize(value:any,mark:SlateMarkBase[]){
        return HTMLSerializer.GetInstance(mark).serialize(value);
    }

    public static Deserialize(value:any,mark:SlateMarkBase[]){
        return HTMLSerializer.GetInstance(mark).deserialize(value);
    }

}